
define(
	'Code25.Wishlist'
	, [
		"underscore", "jQuery", "Profile.Model"
	]
	, function (
		_, jQuery, ProfileModel
	) {
		'use strict';

		return {
			mount: function (container) {

				var ProductListDetailsView=require("ProductList.Details.View");

				function allowKeyword(text, keyword) {
					if (keyword && text) {
						text = text.toLowerCase();
						var keywords = keyword.toLowerCase().split(" ");
						var allowAddress;

						allowAddress = true;
						for (var k = 0; k < keywords.length; k++) {
							if (text.indexOf(keywords[k]) == -1) {
								allowAddress = false;
								break;
							}
						}
						return allowAddress;

					}
					return true;
				}

				function updateFilter(e) {

					var keyword = e.target.value;

					var $infos = this.$el.find('tr');
					var $cell;
					var show = [], count = 0,hide=0;
					$infos.each(function (e) {
						var $this = $(this);
						
						if (allowKeyword($this.text(), keyword)) {
							$this.show();
							count++;
						} else {
							$this.hide();
							hide++;
						}
					})
					if(hide>0){
					this.$el.find(".list-header-view-select-all").hide();
					}else{
						this.$el.find(".list-header-view-select-all").show();
					}

				}

				ProductListDetailsView.prototype.events['change input[type="text"]'] = 'updateFilter';
				ProductListDetailsView.prototype.events['keyup input[type="text"]'] = 'updateFilter';
				ProductListDetailsView.prototype.updateFilter = updateFilter;
			}
		};

	});
